export default {
    generateQRCode: 'umall/business/consumer/vaild/generateQRCode', // 圖形驗證碼
    phoneNo: 'umall/business/consumer/phoneNo/getList', // 号码批量展示    
    phoneBoss:'umall/business/consumer/bossApp/getList',//號碼列表boss
    uploadPict: 'umall/business/consumer/picture/uploadPict', // 圖片上傳
    uploadPicOcr: 'umall/ocr/webservice/ocr/uploadPict', // 圖片上傳ocr识别
    isHkidValid: 'umall/business/consumer/vaild/isHkidValid', // 檢測身份證是否正確
    isHkidValidBoss: 'umall/business/consumer/bossApp/hkidCheck', // 檢測身份證是否正確
    payTypeList: 'umall/order/adapter/payTypeList', // 獲取支持支付方式列表    
    newQueryByCode: 'umall/business/consumer/hint/newQueryByCode', // 獲取三項協議(Umall購物條款及細則\私隱政策聲明\一般個人資料收集聲明)
    isMnpInfoValid: 'umall/business/consumer/vaild/isMnpInfoValid', // 繳驗協號
    isMnpInfoValidBoss: 'umall/business/consumer/bossApp/mnpCheck', // 繳驗協號
    msisdnCheck: 'umall/business/consumer/bossApp/msisdnCheck', // 新號預佔+繳驗
    msisdnPreempt: 'umall/business/consumer/bossApp/msisdnPreempt', //家居电话预占 -- 谢聪
    init: 'umall/business/consumer/boss/eshopEnrollOrderInfo/init', // 初始化业务订单,获取订单号
    // getContract: 'umall/business/consumer/paperless/getContract', // 获取合約
    getContract: 'umall/attachment/consumer/paperless/getContract', // 获取合約    
    isMgmCodeValid: 'umall/business/consumer/handle/checkReferrerForCorp', //檢驗推薦碼是否正確
    dictionary: 'moses/app/admin/appDictionary/json', //数据字典
    getSfLockerList: 'umall/business/consumer/cabinetc/getSfLockerList', //獲取順豐櫃列表
    getDiscontsData: 'umall/business/consumer/discounts/getDiscontsData',  //獲取優惠信息
    getBusinessVas: 'umall/business/consumer/vas/getBusinessVas', //获取vas信息
    submitRecord: 'umall/track/business/app/registerRecord/submitRecord',  //提交用戶填寫的信息
    trackOrder: {
        add: 'umall/track/business/app/trackOrder/add', // 预约订单添加
    },
    check: {
        ippCheck: 'umall/business/consumer/bossApp/ippCheck', // 预付转后付ipp校验
    },
    packageInfo: {
        queryPcPackage: 'umall/business/consumer/packageInfo/queryPcPackage', // 业务包详情查询
        page: 'umall/business/consumer/packageInfo/page', // 业务包分页查询
    },    
    upload: 'moses/upload/file/upload', // 簽名上傳
    sumbitSignaturePic: 'umall/business/consumer/handle/sumbitSignaturePic', // 提交签名
    contract: {
        submitContract: 'umall/business/consumer/contract/submitContract', // 不知道幹嘛，猜測是把簽名合併到合約上
        electronicContract: 'umall/attachment/consumer/contract/electronicContract', // 不知道幹嘛的
    },
    businessInfo: {
        queryPcBusiness: 'umall/business/consumer/businessInfo/queryPcBusiness', // 业务子集详情查询
        getDiscountsAndVas: 'umall/business/consumer/businessInfo/getDiscountsAndVas', // 查询VAS及优惠
        queryShipMethod: 'umall/business/consumer/deliveryMethodInfo/findPage', //獲取物流方式
    },
    pcOrderInfo: {
        queryByPhone: 'umall/business/consumer/pcOrderInfo/queryByPhone', // 訂單查詢提交信息
        submitOrder: 'umall/business/consumer/pcOrderInfo/submitOrder', // 提交表单
        submitOrderBoss: 'umall/business/consumer/boss/eshopEnrollOrderInfo/saveOrderInfo', // 提交表单
        submitOrderBossTwo: 'umall/business/consumer/boss/StoreEnrollOrderInfo/saveOrderInfo', // 提交表单--店鋪模式改造
        queryOrderInfo: "umall/business/consumer/pcOrderInfo/queryOrderInfo" // 根据id查询业务订单
    },    
    maparea: {
        searchAreaAndDistrict: 'umall/business/consumer/maparea/searchAreaAndDistrict', // 獲取地區/區域
        pcSearch: 'umall/business/consumer/maparea/pcSearch' // 搜索地址
    },
    order: {
        create: 'umall/order/adapter/order/create', // 創建訂單
        getOrderInfo: 'umall/order/query/getOrderInfo', // 獲取訂單詳情
        pay: 'umall/order/adapter/pay', // 去付款
        confirmCashPay: 'umall/order/adapter/confirmCashPay', // 確認收款
        verificationCode: 'umall/order/adapter/order/verfiationPatternCode'
    },
    url:{
    	short: 'umall/business/consumer/url/short', // 生成短链接 -- 楊勇闖
    	register:'umall/business/consumer/informationRegistration/add',//謝聰=---5G提交
    	ocr: 'umall/ocr/webservice/ocr/uploadPict',//ocr识别接口
    },
    admin: {
      dectionary: 'moses/app/admin/appDictionary/json', //数据字典
      dectionaryApp: 'moses/app/admin/dictionary/list' //数据字典
    },
    broadband: {  // 寬頻1+N -- 谢聪
      getQuotaAvailable: 'umall/business/consumer/broadbandOrderInfo/getQuotaAvailable', // 查询安装日期
      getQuotaAvailableTime: 'umall/business/consumer/broadbandOrderInfo/getQuotaAvailableTime', // 查询可安装時間
      broadAccountQuery: 'umall/business/consumer/boss/broadbandAndOpenAccount/query', // 查询订单基本信息
      saveOrderInfo: 'umall/business/consumer/boss/broadbandAndOpenAccount/saveOrderInfo', // 保存訂單資料
      getDetails: 'umall/business/consumer/boss/broadbandAndOpenAccount/getDetails', // 查詢訂單詳情
    }
}